import Box from '@material-ui/core/Box';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React, {useCallback} from 'react';

import {DownloadLink} from '../components/displays/download.link';

const useStyle = makeStyles((theme) => ({
    container: {
        height: `calc(100% - ${theme.spacing(1)}px)`
    },
    header: {
        color: '#565a5c',
        fontWeight: 500,
        letterSpacing: '.0375em',
        textTransform: 'uppercase'
    }
}));

// Static data replacing API call
const staticDocuments = [
    {
        category: 'Links',
        index: 0,
        resources: [
            {
                title: 'Invoice Viewer',
                type: 'link',
                url: 'https://dashboard.theice.com/data/invv'
            }
        ]
    }
];

export const DocumentLinksPage: React.FC = React.memo((props) => {
    const classes = useStyle(props);

    const renderCell = useCallback(
        (cell) => (
            <Box
                data-e2e-tag='category'
                data-index={cell.index.toString()}
                data-title={cell.category}
                display='flex'
                flexDirection='column'>
                <Box className={classes.header}>{cell.category}</Box>
                {cell.resources.map((resource) => (
                    <DownloadLink key={resource.title} {...resource} />
                ))}
            </Box>
        ),
        [classes.header]
    );

    return (
        <Box className={classes.container} display='flex' mt={1}>
            <Box display='flex' flexDirection='column' width='100%'>
                {staticDocuments.map((item) => (
                    <Box key={item.index} mb={2}>
                        {renderCell(item)}
                    </Box>
                ))}
            </Box>
        </Box>
    );
});
